import { Divider } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

const ProviderS = styled("div")`
  box-shadow: 0px 1px 1px 1px #f2f2f2;
  padding: 10px;
  height: fit-content;
  min-width: 150px;
  height: 300px;
  width: auto;
  background-color: #ffffff;
`;
const PrviderHeader = styled("div")`
  color: #4678ed;
  font-size: 18px;
  font-weight: 600;
  font-family: Montserrat, SemiBold;
  border-bottom: 2px solid #2196f3;
  padding: 10px;
`;
const TabS = styled("div")`
  margin-top: 10px;
  min-height: 28px;
  height: fit-content;
  font-weight: 500;
  padding: 5px 30px;
  width: 320px;
  font-size: 13.7px;
  font-weight: 500;
  font-family: Montserrat, Medium;
  margin-left: 10px;
  border-radius: 20px;
  &:hover {
    background-color: #c5d7f9;
    width: 320px;
  }
`;
var user = ["All users", "Tom Collins", "Smith,Billy", "Stone,Fred"];
export const Provider = () => {
  const data = user.map((data, index) => {
    return <TabS key={index}> {data}</TabS>;
  });
  return (
    <>
      <ProviderS>
        <PrviderHeader>Providers</PrviderHeader>
        <Divider />
        {data}
      </ProviderS>
    </>
  );
};
